import { useEffect } from 'react';
import Animated, {
    Easing,
    useAnimatedStyle,
    useSharedValue,
    withRepeat,
    withTiming,
} from 'react-native-reanimated';
import { View, type ViewProps } from 'tamagui';

import { useThemeColors } from '../../themes/SmoothieColorTokens';

export const LoadingSkeleton = (props: ViewProps) => {
    const opacity = useSharedValue(0.25);
    const { getColor } = useThemeColors();
    const skeletonColor = getColor('$gray300');
    const skeletonBorderRadius =
        typeof props.borderRadius === 'number' ? props.borderRadius : 6;

    useEffect(() => {
        opacity.value = withRepeat(
            withTiming(0.75, {
                duration: 700,
                easing: Easing.bezier(0.65, 0, 0.35, 1),
            }),
            -1,
            true,
        );
    }, []);

    const animatedStyle = useAnimatedStyle(() => {
        return {
            height: '100%',
            width: '100%',
            borderRadius: skeletonBorderRadius,
            opacity: opacity.value,
            backgroundColor: skeletonColor,
        };
    });

    return (
        <View width="100%" height="100%" {...props}>
            <Animated.View style={[animatedStyle]} />
        </View>
    );
};
